import { render, staticRenderFns } from "./SettingsEmailsTemplatesForm.vue?vue&type=template&id=e3902e94&scoped=true&"
import script from "./SettingsEmailsTemplatesForm.vue?vue&type=script&lang=js&"
export * from "./SettingsEmailsTemplatesForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEmailsTemplatesForm.vue?vue&type=style&index=0&id=e3902e94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3902e94",
  null
  
)

export default component.exports